// /////
// automatically export all routes as one array
// /////

import store from '@/store';
import Fallback from '@/views/Fallback.vue';
import AccessDenied from '@/views/AccessDenied.vue';
import chainGuards, { authenticate } from '@/router/guards';
import { cloneDeep } from 'lodash';

async function setOCByURL(to, from, next) {
  // REFACTOR: relies on initialization of user / authentication
  const hasOC = Boolean(to?.params?.operatingCompanyUrl);

  if (hasOC) {
    const OcId = to.params.operatingCompanyUrl.split('-')[0];
    await store.dispatch('user/setCurrentOperatingCompanyById', OcId);

    if (OcId != store.get('user/currentOperatingCompany')?.id) {
      // loose inequality for ID which is returned as either Number or String from API

      // TODO: add better flow for non-accessible operating company on init, when there is no route to go back to
      next({ name: 'accessDenied', meta: { backRoute: 'login' } });
    } else {
      next();
    }
  } else {
    next();
  }
}

async function setDashboardPageByURL(to, from, next) {
  // REFACTOR: relies on initialization of user / authentication
  const hasDashboardPage = Boolean(to?.params?.dashboardPageUrl);
  
  if (hasDashboardPage) {
    const dashboardPageId = to.params.dashboardPageUrl.split('-')[0];
    await store.dispatch('user/setCurrentDashboardPageById', dashboardPageId);
    next();
  } else {
    next();
  }
}

async function addOCToParams(to, from, next) {
  const OCUrl = await store.get('user/currentOperatingCompanyUrl');
  if (OCUrl != undefined && to.params?.['operatingCompanyUrl'] !== OCUrl) {
    // prevent recursion error if already set!
    const target = cloneDeep(to);
    target.params.operatingCompanyUrl = OCUrl;
    target.redirect = true;
    next(target);
  }
  next();
}

async function addDashboardPageToParams(to, from, next) {
  const dashboardPageUrl = await store.get('user/currentDashboardPageUrl');
  if (dashboardPageUrl != undefined && to.params?.['dashboardPageUrl'] !== dashboardPageUrl) {
    // prevent recursion error if already set!
    const target = cloneDeep(to);
    target.params.dashboardPageUrl = dashboardPageUrl;
    target.redirect = true;
    return next(target);
  }
  next();
}
// wrapper view for globally handling operatingCompany scoped views
const OCMain = {
  // only match strings in defined `id-short_url` pattern
  path: '/:operatingCompanyUrl(\\d+\\-\\w+)/:dashboardPageUrl(\\d+\\-\\w+)/',
  name: 'OC',
  beforeEnter: chainGuards(authenticate, setOCByURL, setDashboardPageByURL, addOCToParams, addDashboardPageToParams),
  beforeUpdate: addOCToParams, addDashboardPageToParams,
  component: {
    // render a single router-view to display child routes inside
    name: 'OperatingCompanyRouteWrapper',
    render(h) {
      return h('router-view');
    },
  },
  children: [],
  redirect: { name: 'dashboard' },
};

// import all default routes
const routes = [];
const RouteFiles = require.context('.', false, /\.route\.js$/);
RouteFiles.keys().forEach(filename => {
  const routesModule = RouteFiles(filename).default || RouteFiles(filename);
  if (routesModule.pubRoutes) {
    routes.push(...routesModule.pubRoutes);
  }
  if (routesModule.OCRoutes) {
    OCMain.children.push(...routesModule.OCRoutes);
  }
});

routes.push(
  // Add any routes that MUST be resolved LAST here.
  OCMain,
  {
    path: '/',
    redirect: { name: 'dashboard' },
  },
  {
    path: '/access-denied',
    name: 'accessDenied',
    component: AccessDenied,
    meta: { layout: 'Basic' },
  },
  {
    path: '*',
    name: 'notFound',
    component: Fallback,
    meta: { layout: 'Basic' },
  }
);

export default routes;
